import jwtDecode from 'jwt-decode';
import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  isAuthenticated: false,
  user: {}
};

const slice = createSlice({
  name: 'authJwt',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // INITIALISE
    getInitialize(state, action) {
      state.isLoading = false;
      state.isAuthenticated = action.payload.isAuthenticated;
      state.user = action.payload.user;
    },

    // LOGIN
    loginSuccess(state, action) {
      state.isAuthenticated = true;
      state.user = action.payload.user;
      // console.debug('Logged in!');
      // console.debug(action.payload.refreshToken);
      // setTimeout(refreshAuthToken, 10000);
    },

    // UPDATE PROFILE
    updateProfileSuccess(state, action) {
      state.isAuthenticated = true;
      state.user = action.payload.user;
    },

    // REGISTER
    registerSuccess(state, action) {
      state.isAuthenticated = true;
      state.user = action.payload.user;
    },

    // LOGOUT
    logoutSuccess(state) {
      state.isAuthenticated = false;
      state.user = null;
    },

    refreshTokenSuccess(state, action) {
      console.debug(action.payload);
    }
  }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

const setRefreshToken = async (refreshToken) => {
  if (refreshToken) {
    localStorage.setItem('refreshToken', refreshToken);
  } else {
    console.debug('No Refresh token found!');
    localStorage.removeItem('accessToken');
    delete axios.defaults.headers.common.Authorization;
  }
};

export async function setSession(accessToken) {
  if (accessToken) {
    localStorage.setItem('accessToken', accessToken);

    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    // console.debug(
    //   'axios.defaults.headers.common.Authorization = ',
    //   `Bearer ${accessToken}`
    // );
  } else {
    localStorage.removeItem('accessToken');
    delete axios.defaults.headers.common.Authorization;
  }
}

export function isValidToken(accessToken) {
  if (!accessToken) {
    return false;
  }
  const decoded = jwtDecode(accessToken);
  const currentTime = Date.now() / 1000;
  // console.debug(decoded.exp - currentTime);
  return decoded.exp > currentTime;
}

// ----------------------------------------------------------------------

export function login({ email, password }) {
  return async (dispatch) => {
    const queryString = `query Login {
      login(username: "${email}", password: "${password}")
        {
            refreshToken,
            accessToken,
            user {
                displayName,
                firstName,
                lastName,
                email,
                id,
                role,
                company
                phoneNumber
            }
        }
     }`;
    const response = await axios.post('/graphql', { query: queryString });

    if (response.data.errors) {
      console.debug(slice.actions.hasError(response.data.errors[0].message));
      throw new Error(response.data.errors[0].message);
    }

    if (response.data.data.login) {
      setSession(response.data.data.login.accessToken);
      setRefreshToken(response.data.data.login.refreshToken);
      dispatch(slice.actions.loginSuccess(response.data.data.login));
    }
  };
}

// ----------------------------------------------------------------------

export async function refreshAuthToken() {
  return new Promise((resolve, reject) => {
    console.debug('Refreshing Token');
    const refreshToken = window.localStorage.getItem('refreshToken');

    const queryString = `query refreshToken {
        refreshToken(refreshToken: "${refreshToken}")
          {
            AccessToken,
            ExpiresIn,
            IdToken
          }
      }`;

    const response = axios.post('/graphql', { query: queryString });
    resolve(response);
  });
}

// ----------------------------------------------------------------------
export async function updateProfile(
  username,
  phoneNumber,
  firstName,
  lastName
) {
  try {
    console.debug('sending update profile request');
    const queryString = `query {
      updateUserAttributes(username: "${username}", phoneNumber: "${phoneNumber}", firstName: "${firstName}", lastName: "${lastName}")
     }`;

    // TODO: Replace attributes after update
    // {
    //     accessToken,
    //     user {
    //         displayName,
    //         firstName,
    //         lastName,
    //         email,
    //         id,
    //         role,
    //         phoneNumber
    //     }
    // }

    const response = await axios.post('/graphql', { query: queryString });

    slice.actions.updateProfileSuccess(response.data);
  } catch (error) {
    slice.actions.hasError(error);
  }
}

// ----------------------------------------------------------------------

export function register({ email, password, firstName, lastName, company }) {
  return async (dispatch) => {
    const queryString = `query {
      createUser(
        email: ${JSON.stringify(email)},
        password: ${JSON.stringify(password)},
        firstName: ${JSON.stringify(firstName)},
        lastName: ${JSON.stringify(lastName)},
        company: ${JSON.stringify(company)}
      )
    }`;

    const response = await axios.post('/graphql', { query: queryString });

    const { accessToken, user } = response.data;

    window.localStorage.setItem('accessToken', accessToken);
    dispatch(slice.actions.registerSuccess({ user }));
  };
}

// ----------------------------------------------------------------------

export function logout() {
  return async (dispatch) => {
    setSession(null);
    localStorage.removeItem('refreshToken');
    localStorage.setItem('lastVisitedPath', '/auth/login');
    sessionStorage.removeItem('last-visited');
    dispatch(slice.actions.logoutSuccess());
  };
}

// ----------------------------------------------------------------------

export function getInitialize() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    console.debug('Get Initialize');
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const refreshToken = window.localStorage.getItem('refreshToken');

      if (accessToken && isValidToken(accessToken)) {
        setSession(accessToken);
        setRefreshToken(refreshToken);

        const queryString = `query {
            getUserProfile {                 
              displayName,
              firstName,
              lastName,
              company,
              email,
              id,
              role,
              phoneNumber
          }
        }`;

        const response = await axios.post('/graphql', { query: queryString });
        dispatch(
          slice.actions.getInitialize({
            isAuthenticated: true,
            user: response.data.data.getUserProfile
          })
        );
      } else {
        console.debug('Not valid token!');
        dispatch(
          slice.actions.getInitialize({
            isAuthenticated: false,
            user: null
          })
        );
      }
    } catch (error) {
      console.error(error);
      dispatch(
        slice.actions.getInitialize({
          isAuthenticated: false,
          user: null
        })
      );
    }
  };
}
